import React from 'react';
import PropTypes from 'prop-types';
import {
  Select,
} from 'antd';

import styles from './Tops.module.css';

const { Option } = Select;

const Tops  = ({
  topsLabel,
  handleSub,
}) => (
  <div className={styles['top-results']}>
    <span className={styles.label}>{topsLabel}:</span>
    <Select
      onChange={handleSub}
      className={styles.control}
      defaultValue={10}
    >
      <Option value={10}>10</Option>
      <Option value={25}>25</Option>
      <Option value={50}>50</Option>
      <Option value={100}>100</Option>
      <Option value={0}>All</Option>
    </Select>
  </div>
);

Tops.propTypes = {
  topsLabel: PropTypes.string.isRequired,
  handleSub: PropTypes.func.isRequired
};

export default Tops;
